export default __webpack_public_path__ + "static/media/menu5.bf2bdb8c.png";